import React from 'react';
import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';

export const AuthShell = ({ title, description, children, titleId = 'email-auth-title' }) => (
  <main className="min-h-[75vh] flex items-center justify-center px-4 py-12 sm:py-20" data-testid="email-auth-shell">
    <div className="w-full max-w-md min-w-0">
      <Link to="/" className="inline-flex max-w-full items-center gap-2 text-xl font-extrabold text-white mb-8 focus-visible:outline focus-visible:outline-2 focus-visible:outline-indigo-400 rounded" data-testid="email-auth-home-link">
        <Activity className="w-7 h-7 text-indigo-400 shrink-0" aria-hidden="true" />
        <span className="break-words">PharmaConsensus</span>
      </Link>
      <h1 className="text-3xl sm:text-4xl font-extrabold text-white mb-3" data-testid={titleId}>{title}</h1>
      {description && <p className="text-sm sm:text-base text-slate-300 mb-8 leading-relaxed" data-testid="email-auth-description">{description}</p>}
      {children}
    </div>
  </main>
);